import { useContext, useState } from 'react';
import { Notification, Placeholder, useToaster } from 'rsuite';
import { Auth } from '../../Contexts/AuthContext';
import cancel from '../../favicon/cancel.svg'
import { APIRequest, ApiUrl } from '../../Helpers/ApiHelper';
import hasError from '../../Helpers/ErrorHelper';
import CustomLoader from './Loader/CustomLoader';

const WithdrawRequestModal = ({ ...props }) => {
    const { showModal, setShowModal } = props;
    const { auth } = useContext(Auth);
    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);
    const toaster = useToaster();
    const [customRanges, setCustomRanges] = useState([
        {
            id: 1,
            value: 50,
            selected: false,
        },
        {
            id: 2,
            value: 100,
            selected: false,
        },
        {
            id: 3,
            value: 500,
            selected: false,
        }
    ]);

    const handleWithdrawalRequest = (item) => {
        setIsLoading(true);
        let confing = {
            url: ApiUrl.withdrawalRequest,
            method: 'POST',
            body: {
                amount : amount,   
            }
        }
     
        APIRequest(
            confing,
            res => {
                setIsLoading(false);
                toaster.push(<Notification type='success' header="Success"  >{res.message}</Notification>, {
                    placement: 'topEnd'
                });
                setShowModal()     
            },

            err => {
                setIsLoading(false);
                if (err?.response?.status === 444){
                    toaster.push(<Notification type='error' header="Error"  >{err?.response?.data?.message}</Notification>, {
                        placement: 'topEnd'
                    });     
                }
                   
            }

        )
    }
    const handleRangeSelection = (range) => {
        const updatedRanges = customRanges?.map(r => r?.id === range.id ? { ...r, selected: true } : { ...r, selected: false });
        setAmount(range?.value);
        setCustomRanges(updatedRanges);
    }

    const showToaster = () => {
        toaster.push(<Notification type="warning" header="Warning" >
            <Placeholder.Paragraph style={{ width: 100, color: 'red' }} rows={0} />Your Wallet does not have sufficent balance  </Notification>
            , {
                placement: 'topEnd'
            });
    }

    const customValidation = (value) => {
        if (value.includes('-') || value === '0') {
            return false;
        } else {
            if (parseFloat(value) > parseFloat(auth?.user?.wallet_balance)) {
                return false;
            }
            return true
        }

    }


    return (
        <>
            {showModal ? (
                <>
                    <CustomLoader visible={isLoading} />
                    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                        <div className="fixed inset-0 z-10 overflow-y-auto">

                            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">

                                <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ">
                                        <div className="close-modal" onClick={setShowModal}>
                                            <img alt="closemodal" src={cancel} />
                                        </div>
                                        <div className="sm:flex ">
                                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Withdrawal request</h3>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">Withdraw money from your wallet to your a/c.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sm:flex ">
                                            <div className="w-full mt-2">
                                                <div className="flex flex-wrap -mx-3 mb-6">
                                                    <div className="w-full px-3">
                                                        <input style={{ width: '100%', textDecoration: 'none', borderRadius: '8px' }} className={`appearance-none block w-full text-gray-700 border-[#c7c7c7]  rounded py-3 px-4 leading-tight focus:outline-none `}
                                                            name="amount"
                                                            value={amount}
                                                            type="number"
                                                            min={0}
                                                            max={parseInt(auth?.user?.wallet_balance)}
                                                            placeholder="Enter amount"
                                                            onChange={(e) => { customValidation(e.target.value) ? setAmount(e.target.value) : showToaster() }}
                                                        />
                                                       
                                                    </div>
                                                </div>
                                                <div className="flex gap-2 ">
                                                    {(customRanges !== undefined) && customRanges?.map(range => (
                                                        <div key={`range-${range?.id}`}>
                                                            {parseFloat(range?.value) <= parseFloat(auth?.user?.wallet_balance) && (
                                                                <span onClick={() => handleRangeSelection(range)} className={`cursor-pointer px-2 py-1  border-2 ${range?.selected ? 'bg-green-500 text-white' : ''}  rounded-lg border-green-500 font-museobb`} > + {range?.value}</span>
                                                            )}
                                                        </div>
                                                    ))}


                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={handleWithdrawalRequest} className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                        <button type="button" className="mt-3 inline-flex w-full text-white justify-center rounded-lg border bg-greenBtn px-4 py-2 text-base font-museob shadow-sm hover:bg-greenBtn focus:outline-none  btn-anim i  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"> Save </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )

};



export default WithdrawRequestModal;
